<template>
  <div class='s-header'>
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 's-header'
}
</script>

<style>
.s-header {
  height: 60px;
}
</style>